import { useMixpanel } from '@/context/mixpanel'
import type { Dispatch, SetStateAction } from 'react'
import { useCallback } from 'react'
import type { useForm } from 'react-hook-form'
import { formatUnits } from 'viem'

export function useMaxAmount({
  form,
  maxAmount,
  decimals,
  setUseAllFunds,
}: {
  form: ReturnType<typeof useForm>
  maxAmount: string
  decimals: number
  setUseAllFunds?: Dispatch<SetStateAction<boolean>>
}) {
  const { trackEvent } = useMixpanel()

  const handleMaxClick = useCallback(() => {
    form.setValue('amount', formatUnits(BigInt(maxAmount), decimals), { shouldValidate: true })
    setUseAllFunds?.(true)
    trackEvent('Prepopulated amount button clicked', { Amount: 'Full balance in input' })
  }, [form, maxAmount, decimals, setUseAllFunds, trackEvent])

  return { handleMaxClick }
}
